import { PremiumManager } from '../PremiumManager';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class PremiumManagerFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/premium`);
  }

  public createPremiumManager(token: string): PremiumManager {
    return new PremiumManager(this.apiClientFactory.createAuthorizedClient(token));
  }
}
